import { render, staticRenderFns } from "./TestReportInfoPublic.vue?vue&type=template&id=86ae6936&scoped=true&"
import script from "./TestReportInfoPublic.vue?vue&type=script&lang=js&"
export * from "./TestReportInfoPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ae6936",
  null
  
)

export default component.exports